import React from 'react'
import { Provider } from 'react-redux'

import IdFinder from '../id_finder'
import { Product } from '../components/product'
import Themed from 'store/v2/react/components/Themed'

const store = window.booqableStore

export class ProductGroup extends React.Component {
  static displayName = 'ProductGroupContainer'

  render = () => {
    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component" style={{ display: 'none' }}>
            <IdFinder {...this.props}>
              <Product />
            </IdFinder>
          </div>
        </Themed>
      </Provider>
    )
  }
}
